module.exports = __webpack_public_path__ + "static/media/colocada1.8a4d71df.png";